export enum AOSError
{
    NO_ERROR,
    BAD_REQUEST,
    EXISTS,
    NOT_FOUND,
    EXCEPTION,
    UNABLE_TO_SEND_EMAIL,
    LICENSE_CODE_NOT_FOUND
}